import React from 'react';
import styles from './AdminDiscountList.module.scss';
import AdminTableList from '../../../components/admin/AdminTableList/AdminTableList';
import { userList } from '../../../redux/actions/user/userList';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { postList } from '../../../redux/actions/app/postList';
import Player from 'react-player';
import { discountList } from '../../../redux/actions/app/discountList';

const AdminDiscountList = () => {
  const columns = [
    {
      label: 'Фото/Видео',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100px', height: '100px' }}>
          <Box component={'img'} src={val?.image} sx={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '6px', margin: '0 auto' }}></Box>
        </Box>
      ),
    },
    {
      label: 'Название',
      onTransform: (val) => val?.title,
    },
    {
      label: 'Описание',
      onTransform: (val) => <Box sx={{ textAlign: 'left', maxWidth: '300px', width: '300px', whiteSpace: 'normal' }}>{val?.description}</Box>,
    },
    {
      label: 'Автор',
      onTransform: (val) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginRight: 'auto' }}>
          <Box component={'img'} src={val?.club?.logo} sx={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '50%', margin: '0 auto' }}></Box>
          <Box>{val?.club?.name}</Box>
        </Box>
      ),
    },
    {
      label: 'Адрес',
      onTransform: (val) => val?.club?.address,
    },
  ];
  return (
    <div>
      <AdminTableList title={'Акции'} sliceName={'app'} actionName={'discountList'} fetch={discountList} pathEdit="/admin/promotion/edit" columns={columns} textEmpty={'Акций нет'} />
    </div>
  );
};

export default AdminDiscountList;
